import React, { useCallback } from "react";

import { faArrowTurnDownLeft } from "@fortawesome/pro-solid-svg-icons/faArrowTurnDownLeft";
import { faMapMarkerAlt } from "@fortawesome/pro-solid-svg-icons/faMapMarkerAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import SavedAddressRow from "@app/component/savedLocations/SavedAddressRow";
import SetSavedAddressRow from "@app/component/savedLocations/SetSavedAddressRow";
import GlobalSearchItemType from "@app/enum/GlobalSearchItemType";
import GlobalSearchItem from "@app/types/globalSearch/GlobalSearchItem";

import {
  isAddressGlobalSearchItem,
  isSavedLocationGlobalSearchItem,
  isSetSavedLocationGlobalSearchItem,
} from "../../util/assert";
import LeadFinderSearch from "../LeadFinderSearch";

import Icon from "./Icon";
import styles from "./Item.module.scss";
import SubTitle from "./SubTitle";
import Title from "./Title";

interface ItemProps {
  index: number;
  isSelected: boolean;
  item: GlobalSearchItem;
  onClick: (item: GlobalSearchItem) => void;
  onSetSelected: (index: number) => void;
}

const Item = ({ index, isSelected, item, onClick, onSetSelected }: ItemProps) => {
  const handleClick = useCallback(() => {
    onClick(item);
  }, [item, onClick]);

  const handleMouserMove = useCallback(() => {
    onSetSelected(index);
  }, [index, onSetSelected]);

  const renderBody = () => {
    if (isSavedLocationGlobalSearchItem(item)) {
      return <SavedAddressRow savedAddress={item.savedAddress} />;
    }
    if (isSetSavedLocationGlobalSearchItem(item)) {
      return <SetSavedAddressRow type={item.savedAddressType} />;
    }
    if (isAddressGlobalSearchItem(item)) {
      return (
        <div className={styles.mainPartWrapper}>
          <div className={cn(styles.icon, styles.queryIcon)}>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </div>
          <div className={cn(styles.text, styles.name)}>{item.prediction.description}</div>
        </div>
      );
    }
    return (
      <div className={styles.mainPartWrapper}>
        <div className={styles.icon}>
          <Icon item={item} />
        </div>
        <div className={styles.text}>
          <Title item={item} />
          <SubTitle item={item} />
        </div>
      </div>
    );
  };

  if (item.type === GlobalSearchItemType.LEAD_FINDER) {
    return (
      <LeadFinderSearch
        isSelected={isSelected}
        onClick={handleClick}
        onMouseMove={handleMouserMove}
      />
    );
  }
  return (
    <div
      className={cn(styles.container, { [styles.selected]: isSelected })}
      data-global-search-index={index}
      onClick={handleClick}
      onMouseMove={handleMouserMove}
    >
      {renderBody()}
      {isSelected && (
        <div>
          <FontAwesomeIcon className={styles.enterIcon} icon={faArrowTurnDownLeft} />
        </div>
      )}
    </div>
  );
};

export default Item;
